import _ from "lodash";
import { constants } from "~/constants";
import { SupportedLanguage } from "./SupportedLanguage";

/**
 * Get the language from the URL. If the language is not supported, the default
 * language will be returned.
 *
 * Example:
 *   - https://example.com/hr/... -> hr
 *   - https://example.com/fr/... -> fr
 *   - https://example.com/... -> en (default language)
 * @returns {SupportedLanguage} The language from the URL.
 */
export function getLanguageFromURL(pathname?: string) {
  const maybeLanguage = (pathname ?? window.location.pathname).split("/")[1];

  const supportedLanguageList = _.without(
    Object.values(SupportedLanguage),
    constants.DEFAULT_LANGUAGE,
  );
  const language = (
    supportedLanguageList.includes(maybeLanguage as SupportedLanguage)
      ? maybeLanguage
      : constants.DEFAULT_LANGUAGE
  ) as SupportedLanguage;

  return language;
}
